export const CLASSIC_STORY_POINT_TEST_ID =
	'issue-field-classic-story-point.ui.issue-field-classic-story-point';
export const CLASSIC_STORY_POINT_TEST_ID_WITH_INLINE_EDIT =
	'issue-field-classic-story-point.ui.issue-field-classic-story-point--container';
export const CLASSIC_STORY_POINT_READ_ONLY_TEST_ID_WITH_INLINE_EDIT =
	'issue-field-classic-story-point.ui.issue-field-classic-story-point--read-only-container';
export const CLASSIC_STORY_POINT_READ_VIEW_TEST_ID =
	'issue-field-classic-story-point.ui.issue-field-classic-story-point-read-view';
